// extracted by mini-css-extract-plugin
module.exports = {"sidebar_toggle":"sidebar-toggle_sidebar_toggle__MEjis"};